import { useMutation } from '@tanstack/react-query';
import * as Api from '../api';
import * as Types from '../types';

/** Step 1: send a recovery OTP to the phone, returns a challenge reference. */
export const useStartPhoneRecover = () =>
  useMutation({
    mutationFn: async (values: Types.IApi.StartPhoneRecover.Request) => {
      const { data } = await Api.StartPhoneRecover(values);
      return data;
    },
  });

/** Resend the recovery OTP for an active challenge. */
export const useResendPhoneRecover = () =>
  useMutation({
    mutationFn: async (values: Types.IApi.PhoneChallenge.Request) => {
      const { data } = await Api.ResendPhoneRecover(values);
      return data;
    },
  });

/** Step 2: verify OTP and set a new password (does not sign in). */
export const useCompletePhoneRecover = () =>
  useMutation({
    mutationFn: async (values: Types.IApi.CompletePhoneRecover.Request) => {
      const { data } = await Api.CompletePhoneRecover(values);
      return data;
    },
  });
